<template lang="html">
  <div class="grid-x atom-contents">
    <div
      ref="button"
      tabindex="0"
      class="small-12 cell wide-btn vertical-align-middle success"
      :class="{ active }"
      @click="clicked"
      @keyup="clicked"
    >
      {{ buttonText }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonType: {
      type: String,
      required: false,
      default: '',
    },
    fontColor: {
      type: String,
      required: false,
      default: '',
    },
    fontSize: {
      type: String,
      required: false,
      default: '',
    },
    height: {
      type: String,
      required: false,
      default: '',
    },
    isBold: {
      type: Boolean,
      required: false,
    },
    width: {
      type: String,
      required: false,
      default: '191px',
    },
  },
  created() {

  },
  mounted() {
    if (this.buttonType === 'failure') {
      this.$refs.button.classList.remove('success');
      this.$refs.button.classList.add('failure');
    }
    if (this.fontColor) {
      this.$refs.button.style.color = this.fontColor;
    }
    if (this.fontSize) {
      this.$refs.button.style.fontSize = this.fontSize;
    }
    if (this.height) {
      this.$refs.button.style.height = this.height;
    }
    if (this.isBold) {
      this.$refs.button.style.fontWeight = 'bold';
    }
    if (this.width) {
      this.$refs.button.style.width = this.width;
    }
  },
  methods: {
    clicked() {
      this.$emit('clicked');
    },
  },
};
</script>

<style lang="scss" scoped>

  /* - Sizing and layout - */

  $grid: 12px;

  /* - Colour - */

  $secondary-color: #c4cace;
  $primary-accent-color: #50e3c2;
  $focus-text-color: #4a5b68;

  .vertical-align-middle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .atom-contents {
    height: inherit;
  }

  .wide-btn {
    border: solid 1px $secondary-color;
    border-radius: 2 * $grid;
    color: $focus-text-color;
    cursor: pointer;
    font-size: 12px;
    height: 4 * $grid;
    letter-spacing: $grid / 4;
    line-height: 2 * $grid;
    text-align: center;
    text-transform: uppercase;
  }

  .wide-btn:hover, .wide-btn.active {
    &.success {
      background-color: $primary-accent-color;
    }
    &.failure {
      background-color: #E34F4F;
    }
    border: none;
    color: #fff;
    font-weight: 600;
  }

  .wide-btn.active:hover {
    &.success {
      background-color: #49CCAD;
    }
    &.failure {
      background-color: #CC4848;
    }
  }

</style>
